<phdsoft-sideboard
  class="automatic-plan-area-wizard-sideboard"
  [options]="optionsWindow"
  (ok)="submit()"
  (cancel)="closeWindow()"
>
  <div content *ngIf="true" class="area-wizard-content">
    <div class="page-container">
      <div class="wizard-step-identity" aria-live="polite">
        <div *ngIf="pageIndex == 0" class="wizard-step-current">
          <span class="wizard-step-marker" aria-hidden="true"></span>
          <mat-label class="wizard-step-name">General Settings</mat-label>
          <span class="wizard-step-position">Step 1 of 2</span>
        </div>

        <div *ngIf="pageIndex == 1" class="wizard-step-current">
          <span class="wizard-step-marker" aria-hidden="true"></span>
          <mat-label class="wizard-step-name">Area Settings</mat-label>
          <span class="wizard-step-position">Step 2 of 2</span>
        </div>
      </div>

      <div class="slide-navigation-buttons">
        <button
          *ngIf="pageIndex > 0"
          id="basic"
          class="wizard-navigation-button"
          type="button"
          mat-button
          (click)="back()"
        >
          <mat-icon aria-hidden="true">chevron_left</mat-icon>
          Back
        </button>

        <button
          *ngIf="pageIndex != 1"
          id="basic"
          class="wizard-navigation-button wizard-navigation-button--next"
          type="button"
          mat-button
          (click)="next()"
        >
          Next
          <mat-icon aria-hidden="true">chevron_right</mat-icon>
        </button>
      </div>

      <div *ngIf="pageIndex == 0" class="slide-body general-settings-step">
        <div class="region-select-container">
          <phdsoft-region-select
            *ngIf="isGeneralSettingsLoaded"
            [Regions]="_AutomaticPoints.GeneralSettings.Regions"
            (SelectRegion)="onSelectRegion($event)"
            (SelectSection)="onSelectSection($event)"
          >
          </phdsoft-region-select>
        </div>
      </div>

      <div *ngIf="pageIndex == 1" class="slide-body area-settings-step">
        <div class="area-settings-content">
          <form #signUpForm="ngForm" class="normal-form area-settings-form">
            <mat-checkbox
              class="area-settings-checkbox"
              value="3"
              [(ngModel)]="_AutomaticPoints.AreaSettings.AreaForCriticalAreas"
              [ngModelOptions]="{standalone: true}"
              id="al3"
              binary="true"
            >
              Position areas on critical areas
            </mat-checkbox>
          </form>
        </div>
      </div>
    </div>
  </div>
</phdsoft-sideboard>
